/* eslint-disable camelcase */
/* eslint-disable no-unused-vars */
/* eslint-disable import/no-unresolved */
/* eslint-disable import/extensions */
/* eslint-disable object-curly-newline */
/* eslint-disable no-trailing-spaces */

import { observable, makeObservable, action, runInAction } from 'mobx';
import { Category, Project } from '../Global/interface';
import categoryService from '../Services/categoryService'; 
import Constant from '../Global/Constant';

export interface CategoryProps {
    categories: Array<Category>,
    category: Category,
    project: Project,
    getCategories: () => void,
}

class CategoryStore {
    categories: Array<Category> = [];

    category: Category|null = null;

    project: Project|null = null;

    constructor() {
        makeObservable(this, {
            categories: observable,
            category: observable,
            project: observable,
            getCategories: action,
            setCategory: action,
            setProject: action,
        });
    }

    setCategory = (category: Category|null) => {
      runInAction(() => {
        this.category = category;
      });    
    };

    setProject = (project: Project) => {
      runInAction(() => {
        this.project = project;
      });
    }

    getCategories = async () => new Promise((resolve, reject) => {
        categoryService.getCategory()
        .then((response: any) => {
          if (response && response?.data) {
            runInAction(() => {
                this.categories = response?.data?.filteredCategoryList;
              });
          }
          resolve(null);
        })
        .catch((error:any) => {
          reject(error?.response?.data?.error?.message || Constant.defaultErrorMessage);
        });
    });
}

export default new CategoryStore();
